import * as React from 'react';

type SidebarContext = {
  state: 'expanded' | 'collapsed';
  open: boolean;
  /** `persist: false` applies the change without recording it as the user's preference. */
  setOpen: (open: boolean, options?: { persist?: boolean }) => void;
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
  isMobile: boolean;
  toggleSidebar: () => void;
};

const SidebarContext = React.createContext<SidebarContext | null>(null);

function useSidebar(): SidebarContext {
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider.');
  }

  return context;
}

/**
 * Whether the component is rendering inside a SidebarProvider. For components that render
 * in both sidebar and standalone contexts and adapt their presentation to placement;
 * branches that only render inside the sidebar can then use `useSidebar` directly.
 */
function useIsInSidebar(): boolean {
  return React.useContext(SidebarContext) !== null;
}

export { SidebarContext, useIsInSidebar, useSidebar };
